<script>
	import { onMount } from 'svelte'
	import { adminUpdateFoodsEntry } from '../AdminModule.svelte'
	import { urlAdmin } from '../../../library/scripts/Setup.svelte'
	import TwoCols from '../../../library/columLayouts/TwoCols.svelte'
	import FoodPreview from './FoodPreview.svelte'
	import FoodEntry from './FoodEntry.svelte'

	//holds the menu objects
	let menu = []

	//load the menu from db
	const fetch_menu = async () => {
		const fetchDrinks = await fetch(urlAdmin, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				cmd: 'get_foods',
			}),
		})

		const dataResponse = await fetchDrinks.json()

		if (dataResponse.fetch === 0) {
			adminUpdateFoodsEntry.set('[]')
			sessionStorage.setItem('foods', '[]')
			return
		}
		dataResponse.fetch.forEach((item) => {
			let tmpItem = {
				category: item[0],
				id: item[1],
				name: item[2],
				description: item[3],
				price: item[4],
				currency: item[5],
				menuorder: item[6],
			}

			//add the item at the beginning of the array menu
			menu.unshift(tmpItem)
		})

		adminUpdateFoodsEntry.set(JSON.stringify(menu))
		sessionStorage.setItem('foods', JSON.stringify(menu))
	}
	onMount(() => {
		fetch_menu()
	})
</script>

<body style="background-color: black;">
	<TwoCols column="290px" alignVertical="start">
		<div slot="column1">
			<FoodEntry />
		</div>

		<div slot="column2">
			<FoodPreview />
		</div>
	</TwoCols>
</body>
